module.exports = __webpack_public_path__ + "static/img/17041B_1_2_R_20211028_fit.1f42493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17041B_1_2_R_20211028_fit.png
// module id = YpiD
// module chunks = 0